import React, { Component } from 'react';
import styled from '@emotion/styled';

import Slice from './FullColoredSlice';
import UIWidth from './UIWidth';

import Bg from './img/bg-square.svg';
import { SECONDARY_COLOR } from './ThemeIFProfs';

const BgPlaceholder = styled.div`
  @media (min-width: ${props => props.theme.tablet}) {
    ${props => {
      if (props.bgIcon) {
        return 'background-image: url(' + props.bgIcon + ');';
      }
    }};
    background-repeat: no-repeat;
    background-position: 10rem 30%;
    background-size: auto 10rem;
  }
  @media print {
    background-image: none;
  }
`;

class BreadcrumbAndHeading extends Component {
  render() {
    return (
      <Slice customColor={SECONDARY_COLOR} withBackgroundImage={Bg.src}>
        <BgPlaceholder bgIcon={this.props.bgIcon}>
          <UIWidth alternateWidth>{this.props.children}</UIWidth>
        </BgPlaceholder>
      </Slice>
    );
  }
}

export default BreadcrumbAndHeading;
